import * as React from "react"
import { useMagicLinkToken } from "@digits-shared/hooks/useMagicLinkToken"
import useRouter from "@digits-shared/hooks/useRouter"
import { type OnboardingProps } from "src/frontend/components/Public/Onboarding/OnboardingContext"
import { OnboardingStep } from "src/frontend/components/Public/Onboarding/reducer"

export function useInitialLoginState() {
  const {
    location: { state },
  } = useRouter()
  const { token } = useMagicLinkToken()

  return React.useMemo(() => {
    // if there is a magic link token, direct the user to the Magic Link Loading screen
    const initialState = token ? OnboardingStep.MagicLinkLoading : OnboardingStep.SignIn
    const emailAddress = state?.email
    const invitationToken = state?.invitationToken
    const redirectPath = state?.redirectPath ? atob(state?.redirectPath) : "/"

    return {
      initialState,
      emailAddress,
      invitationToken,
      redirectPath,
    } as OnboardingProps
  }, [state?.email, state?.invitationToken, state?.redirectPath, token])
}
